module.exports = __webpack_public_path__ + "img/21.d08c5a59.png";